import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from '../../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelineContext.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Phases_getInstance153dg9ipormlv as Phases_getInstance } from '../../request/HttpRequestPipeline.mjs';
import {
  isSuspendFunction153vlp5l2npj9 as isSuspendFunction,
  isInterface3d6p8outrmvmk as isInterface,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  Sender4pyqqer9k7up as Sender,
  Plugin_getInstance326p2fy5fh97r as Plugin_getInstance,
} from '../HttpSend.mjs';
import { HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder } from '../../request/HttpRequest.mjs';
import { plugin3vxt624hnu3pv as plugin } from '../HttpClientPlugin.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$intercept, it, $completion) {
  var tmp = $this.w5u_1($this$intercept.o4r_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var SetupRequest$install$slambdaClass;
function SetupRequest$install$slambda() {
  if (SetupRequest$install$slambdaClass === VOID) {
    class $ {
      constructor($handler) {
        this.w5u_1 = $handler;
      }
      z5g($this$intercept, it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$intercept, it), $completion);
      }
      vd(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.z5g(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    SetupRequest$install$slambdaClass = $;
  }
  return SetupRequest$install$slambdaClass;
}
function SetupRequest$install$slambda_0($handler) {
  var i = new (SetupRequest$install$slambda())($handler);
  var l = ($this$intercept, it, $completion) => i.z5g($this$intercept, it, $completion);
  l.$arity = 2;
  return l;
}
var SetupRequestClass;
function SetupRequest() {
  if (SetupRequestClass === VOID) {
    class $ {
      x5u(client, handler) {
        var tmp = Phases_getInstance().n5m_1;
        client.c5g_1.s4r(tmp, SetupRequest$install$slambda_0(handler));
      }
      s5m(client, handler) {
        return this.x5u(client, (!(handler == null) ? isSuspendFunction(handler, 1) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SetupRequest');
    SetupRequestClass = $;
  }
  return SetupRequestClass;
}
var SetupRequest_instance;
function SetupRequest_getInstance() {
  return SetupRequest_instance;
}
var SenderClass;
function Sender_0() {
  if (SenderClass === VOID) {
    class $ {
      constructor(httpSendSender, coroutineContext) {
        this.q5p_1 = httpSendSender;
        this.r5p_1 = coroutineContext;
      }
      ew() {
        return this.r5p_1;
      }
      s5p(requestBuilder, $completion) {
        return this.q5p_1.w5s(requestBuilder, $completion);
      }
    }
    initMetadataForClass($, 'Sender', VOID, VOID, [CoroutineScope()], [1]);
    SenderClass = $;
  }
  return SenderClass;
}
var Send$install$slambdaClass;
function Send$install$slambda() {
  if (Send$install$slambdaClass === VOID) {
    class $ {
      constructor($handler, $client) {
        this.y5u_1 = $handler;
        this.z5u_1 = $client;
      }
      a5v($this$intercept, request, $completion) {
        return this.y5u_1(new (Sender_0())($this$intercept, this.z5u_1.b5g_1), request, $completion);
      }
      vd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Sender()) : false) ? p1 : THROW_CCE();
        return this.a5v(tmp, p2 instanceof HttpRequestBuilder() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    Send$install$slambdaClass = $;
  }
  return Send$install$slambdaClass;
}
function Send$install$slambda_0($handler, $client) {
  var i = new (Send$install$slambda())($handler, $client);
  var l = ($this$intercept, request, $completion) => i.a5v($this$intercept, request, $completion);
  l.$arity = 2;
  return l;
}
var SendClass;
function Send() {
  if (SendClass === VOID) {
    class $ {
      b5v(client, handler) {
        var tmp = plugin(client, Plugin_getInstance());
        tmp.m5t(Send$install$slambda_0(handler, client));
      }
      s5m(client, handler) {
        return this.b5v(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'Send');
    SendClass = $;
  }
  return SendClass;
}
var Send_instance;
function Send_getInstance() {
  return Send_instance;
}
//region block: init
SetupRequest_instance = new (SetupRequest())();
Send_instance = new (Send())();
//endregion
//region block: exports
export {
  Send_instance as Send_instance3smuuitxedznj,
  SetupRequest_instance as SetupRequest_instance7itfp4kmymbg,
  Sender_0 as Sender1wtdgti85uk42,
};
//endregion

//# sourceMappingURL=CommonHooks.mjs.map
